/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsUserPoolDetails204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsUserPoolDetails505Schema = z.any();

export const optionsUserPoolDetailsMutationResponseSchema = z.lazy(() => optionsUserPoolDetails204Schema);
